import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "It ain't stupid if it works",
  "description": "",
  "published": "2017-02-01T00:00:00.000Z",
  "redirect_from": ["/blog/aint-stupid-works/swizec/7408"],
  "categories": "Technical",
  "hero": "./img/WPQMsys.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`How do you send your friendly neighborhood data scientist 1,571,043 messages to play with?`}</p>
    <p>{`?`}</p>
    <p>{`Well, the easiest would be something like this:`}</p>
    <pre><code parentName="pre" {...{}}>{`username: MR_SCIENTIST
password: PLEASE_DONT_FUCK_UP_OUR_PRODUCTION_DATABASE
url: postgres://user:pass@ec2-54-225-230-243.compute-1.amazonaws.com:5432/somepath
`}</code></pre>
    <p>{`Excellent! It took you 30 seconds to find the credentials and 2 minutes to write an email. Now all The Scientist has to do is connect to your database, learn an undocumented schema of 114 tables, run some queries, and make absolutely certain that he doesn't mess anything up. He also have to be careful because this is production data and if something goes wrong here, the latest untested backup is 8 hours old.`}</p>
    <p>{`Ok, the "access to production" part is bad.`}</p>
    <p>{`Surely there's a slave database somewhere that has a copy of all data!? Lol, nope.`}</p>
    <p>{`A-ha! Send the latest binary dump. That way The Scientist can load it up locally and fetch whatever he needs.`}</p>
    <p>{`That's 21GB of data. 1.8GB compressed. It's not `}<em parentName="p">{`that`}</em>{` big for a production DB, but it sure sucks whenever you load it on your laptop. It takes forever to download from the server and upload back to another server.`}</p>
    <p>{`No, no, that won't work. The analysis doesn't need everything you have, and The Scientist sure as hell doesn't wanna learn your crazy 100+ table schema.`}</p>
    <p>{`Not like you understand the whole thing yourself. Just the parts you built.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "736px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/d4fe9ef6d206872cdb01d827ca7d6f2d/97cfc/WPQMsys.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "73.54260089686098%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'295\\'%20viewBox=\\'0%200%20400%20295\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M216%20119c-23%203-32%208-39%2022a64%2064%200%2000-1%2061c4%208%204%208%203%2014a187%20187%200%20001%2059l-7%201c-7%200-7-1-8-3-1-5-6-5-44-5l-34-1c0-2%202-2%2019-2l21-1c5-2%2012-9%2012-13a1165%201165%200%2000-20-95c-1-2-6-2-45-2-48%200-47%200-53%206l-3%204v8l2%2014c4%2010%2016%2065%2016%2068s-1%2013-3%2019c0%202%200%202-14%202-15%200-19%201-19%202l15%201%2015%201-2%203c-4%207-6%206%2025%206a610%20610%200%200088-5l24-2c4-2%2010-2%2053-2a1853%201853%200%200077%200l-25%205c-39%206-47%208-45%209s8%201%2028-3a7979%207979%200%200150-9l5-1v7c0%206%200%207%202%207l1-9v-9h-33v-5c-3-21-4-26-10-39-6-16-6-16%202-26%2016-17%2020-34%2014-55-6-25-31-37-68-32m2%203c-18%203-29%207-35%2014s-11%2022-11%2031c0%204%200%204%205%205%2012%202%2012%202%2014%200%201-2%201-2%202%200v3l-3%205c0%205-4%208-10%208s-6%200-3%209c4%208%205%208%209%204l3-4h10c15%200%2018%202%2030%2019%207%2010%206%2010%2018%204%2010-5%2020-13%2027-24%208-11%209-17%209-28%200-24-11-39-31-45-7-1-26-2-34-1M27%20160l-3%203%2042%201h43l1%207a27221%2027221%200%200020%2087l3-3%203-3-6-31-9-48-3-16H30l-3%203m-6%208l1%208%201%206%2033%201c42%201%2040%202%2045-7l4-8c0-2-83-2-84%200m183%201l1%204%203%208c1%206%203%208%209%209%2010%202%2023-3%2026-10%201-3%200-9-2-10l-16%201c-14%201-15%201-17-1-3-2-4-2-4-1m-101%2010l-3%206%203%2011a3131%203131%200%200114%2061l5%202h4v-3a3338%203338%200%2000-18-83l-5%206m118-5c-12%201-12%201-9%209%203%207%2023%205%2027-3%204-7%201-8-18-6m-49%204c0%205%202%207%207%207s8-1%208-5c1-3%201-4-8-5h-7v3M25%20189l12%2053%206-36v-4h11a1418%201418%200%200029%203l-18%201-19-1v3l-9%2061v5h20l20-1%208-69c2-2%205-1%205%201%204%2011%204%2017%200%2041l-2%2010v4h13c12%200%2013%200%2013-2l-12-49-5-21-16-1-36-1-20-1v4m167%2014c-5%200-7%202-7%206%200%203%2012%2012%2019%2015%205%202%2025%204%2027%202%200-1-9-15-13-19l-10-4h-16M86%20220c-4%2034-6%2054-3%2052l7-53c-1-9-3-9-4%201m95%202c-1%2011%200%2035%201%2045%202%2011%203%2012%2015%202%2015-11%2039-35%2039-38l-14-1c-17-1-23-3-33-11l-6-5-2%208m71%200c-10%205-13%209-10%2016%203%208%207%2021%208%2030l2%208%202-8c3-11%204-11%205-25%203-15%202-18%200-21l-2-3-5%203m12%2015a438%20438%200%2000-6%2029l-2%209h18c2-4-6-41-9-41l-1%203m-35%209a272%20272%200%2001-33%2029c-1%201%2010%201%2025%201h27l-1-5c-1-12-8-34-10-34l-8%209m-80%2029v5h6c6%200%207-1%207-3%200-3-2-4-10-6-3-1-3-1-3%204m-36-2l-16%201-18%202-23%201c-22%200-22%200-25%206l-1%202h51v-4c-1-4%201-6%202-1l1%203h16l17-1-1-4c-3-4-2-4%203%200l3%203h24v-9h-16l-17%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/d4fe9ef6d206872cdb01d827ca7d6f2d/ca0a1/WPQMsys.webp 223w", "/static/d4fe9ef6d206872cdb01d827ca7d6f2d/75680/WPQMsys.webp 445w", "/static/d4fe9ef6d206872cdb01d827ca7d6f2d/b8c12/WPQMsys.webp 736w"],
              "sizes": "(max-width: 736px) 100vw, 736px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/d4fe9ef6d206872cdb01d827ca7d6f2d/853b2/WPQMsys.jpg 223w", "/static/d4fe9ef6d206872cdb01d827ca7d6f2d/0a4fe/WPQMsys.jpg 445w", "/static/d4fe9ef6d206872cdb01d827ca7d6f2d/97cfc/WPQMsys.jpg 736w"],
              "sizes": "(max-width: 736px) 100vw, 736px",
              "type": "image/jpeg"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/d4fe9ef6d206872cdb01d827ca7d6f2d/97cfc/WPQMsys.jpg",
              "alt": "WPQMsys",
              "title": "WPQMsys",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`CSV! Comma separated values. It's plaintext, it's easy to build, easy to read, it's from the 70's, it works.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Comma-separated values is a data format that pre-dates personal computers by more than a decade: the IBM Fortran (level H extended) compiler under OS/360 supported them in 1972.`}{`[`}{`5] List-directed ("free form") input/output was defined in FORTRAN 77, approved in 1978. /.../ Comma-separated value lists are easier to type (for example into punched cards) than fixed-column-aligned data, /.../`}</p>
    </blockquote>
    <p>{`That's right. CSV is so old that it was designed to make writing `}<strong parentName="p">{`punch-cards`}</strong>{` easier. Possibly by hand.`}</p>
    <p>{`And yet, it was first `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Comma-separated_values#History"
      }}>{`standardized in 2005`}</a>{`. How hard is it to write `}<inlineCode parentName="p">{`value1,value2,value3`}</inlineCode>{` consistently across systems?`}</p>
    <p>{`¯`}{`\\`}<em parentName="p">{`_`}{`(ツ)`}{`_`}{`/¯`}</em></p>
    <p>{`Great! You're going to send The Scientist a CSV plaintext file. But how do you get it?`}</p>
    <p>{`Well, you're gonna have to connect to the server. That's where connecting to the database is easier. And because you're me, you're running Rails there.`}</p>
    <p>{`You can do something like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ruby"
      }}>{`timespan = many_days_ago.beginning_of_day .. 1.day.ago.end_of_day
puts "session_id,created_at,sent_from,sent_to,content_type,text"
Message.where(created_at: timespan).find_each { |msg|
  puts [
        msg.chat_id,
        msg.created_at,
        msg.sent_from,
        msg.sent_to,
        msg.content_type,
        msg.text
       ].to_csv
} ; 0
`}</code></pre>
    <p>{`That selects all messages from a `}<inlineCode parentName="p">{`timespan`}</inlineCode>{`, walks through them 1000 at a time, and prints a new line of CSV to standard output for each message. Add a `}<inlineCode parentName="p">{`puts`}</inlineCode>{` for the header, and hey presto, a CSV file is born!`}</p>
    <p>{`So how do you get all this data off your server?`}</p>
    <p>{`You run the commands, pipe output to a file using `}<inlineCode parentName="p">{`> epic_data.csv`}</inlineCode>{`, then `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Secure_copy"
      }}>{`scp`}</a>{` the file from your server to your laptop. Lol, nope.`}</p>
    <p>{`You're on Heroku. Every time you connect to The Server, you're actually creating a new one-off dyno that exists only for the lifetime of your connection. All the same basic state as when you deployed, none of the new state.`}</p>
    <p>{`You can dump files into `}<inlineCode parentName="p">{`/tmp`}</inlineCode>{` or `}<inlineCode parentName="p">{`/home/whatever`}</inlineCode>{` all day, but you'll never get them off.`}</p>
    <p><em parentName="p">{`"Ah!"`}</em>{`, you say, `}<em parentName="p">{`"But I can make my dumper script upload the CSV to S3 or something and give me a link"`}</em></p>
    <p>{`Yes. Yes, you can. And then you have to deal with all that.`}</p>
    <p><strong parentName="p"><em parentName="strong">{`OR`}</em></strong>{` you could spin up a rails console with `}<inlineCode parentName="p">{`heroku run rails c`}</inlineCode>{`, run the code above, watch a million and a half lines of CSV fly by on your terminal then…`}</p>
    <p>{`...`}</p>
    <p>{`... copy-paste the whole thing into a text editor.`}</p>
    <p>{`?`}</p>
    <p>{`That's exactly what I did. It worked, too.`}</p>
    <p>{`Run command. Drag-select the first few characters. Scroll to bottom. Wait until text stops flying. Took about 30min. Computer starting to get jittery as Terminal ate RAM like crazy.`}</p>
    <p>{`Shift-click at the bottom of the output. Cmd+C. Click into Emacs. Cmd+V. Beach ball of death.`}</p>
    <p>{`3 minutes later, a 160MB CSV shows up. Cmd+S. Computers are amazing.`}</p>
    <p>{`It ain't stupid if it works™.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      